import React from 'react';
import { CardVariants, Text } from '@clockout-dev/design-elements';
import MetricCard from '../../common/metricCard/MetricCard';
import CurrencyCircleIcon from '../../common/currencyCircleIcon/CurrencyCircleIcon';
import TeamIcon from '../../common/teamIcon/TeamIcon';
import OverdueClockIcon from '../../common/overdueClockIcon/OverdueClockIcon';
import HistoryClockIcon from '../../common/historyClockIcon/HistoryClockIcon';
import KpiActionPill from './KpiActionPill';
import { formatCompactCurrency, formatCompactNumber } from '../../../utils/numbers';
import styles from './styles/kpiRow.module.scss';

/**
 * KPI row rendered when the Advance GL tab is active (Figma 5679-6146).
 *
 * Pure presentational — pulls every value from `data` (returned by the
 * GL Account sub-controller) and forwards `onViewOverdueUsers` to the
 * "Overdue Users" tile so it can drop a `KpiActionPill` in the action
 * slot. Highlight tile uses the `MetricCard` HIGHLIGHT variant for the
 * gradient chrome. Icons live in `common/` so they can be reused on
 * other screens.
 */
function KpiAdvanceRow({ data, onViewOverdueUsers }) {
    const totalOutflow = data?.totalOutflow;
    const incomingFunds = data?.incomingFunds;
    const overdueFunds = data?.overdueFunds;
    const overdueUsers = data?.overdueUsers;

    return (
        <div className={styles.row}>
            <MetricCard
                variant={CardVariants.HIGHLIGHT}
                image={<CurrencyCircleIcon />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabelHighlight}>Total Advance Outflow</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactCurrency(totalOutflow)}</Text>
                </div>
            </MetricCard>
            <MetricCard image={<TeamIcon />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabel}>Incoming Funds</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactCurrency(incomingFunds)}</Text>
                </div>
            </MetricCard>
            <MetricCard
                image={<OverdueClockIcon className={styles.iconDanger} />}
                classNames={{ icon: styles.iconBackground }}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabel}>Overdue Funds</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactCurrency(overdueFunds)}</Text>
                </div>
            </MetricCard>
            <MetricCard
                image={<HistoryClockIcon />}
                action={<KpiActionPill label="View Users" onClick={onViewOverdueUsers} />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabel}>Overdue Users</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactNumber(overdueUsers)}</Text>
                </div>
            </MetricCard>
        </div>
    );
}

export default KpiAdvanceRow;
